export default "__VITE_ASSET__CaN2QHO9__"